<template>
    <CardShell class="flex items-center justify-between" style="height: 80px;" v-if="user">

        <div class="h-inherit flex items-center">

            <!-- profile picture -->
            <img class="h-inherit" src='@/assets/img/avatars/avatar_1.svg'/>
            
            <!-- user data is available for use {{user.name}} -->
            <!-- name and address -->
            <div class="pl3 pl4-m">
                <h5>{{user.name}}</h5>
                <!-- <div v-if="visibleAddress">
                    <div class="formLabel">{{peer.address}} </div>
                    <div class="formLabel">{{peer.city}}</div>
                </div> -->
                <!-- <div v-else class="flex items-center">
                    <div class="mr2 formLabel">Within (dist) KM</div>
                    <img @click="showInfo = true" class="pointer" src="@/assets/img/icon_info.svg"/>
                </div> -->
            </div>

            <OverlayWarning :showWarning="showInfo">
                <InfoOverlay
                    title="Location"
                    description="The location is calculated by.."
                    @cancel="showInfo = false"
                />
            </OverlayWarning>
    
        </div>

        <!-- rating -->
        <RatingBox class="mr3 mr4-m" :rating="user.rating"/>

    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import InfoOverlay from '@/components/global/InfoOverlay.vue';
import RatingBox from '@/components/controls/RatingBox.vue';

export default {
    data() {
        return {
            showInfo: false
        };
    },
    components: {
        CardShell,
        RatingBox,
        OverlayWarning,
        InfoOverlay
    },
    props: {
        visibleAddress: {
            type: Boolean
        },
        user: {
            type: Object
        }
    }
};
</script>
